import useSWR from "swr";
import { type MyQuiz } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/quizzes/me";

/** Quizzes the current user is invited to, with their completion status. */
export function useMyQuizzes() {
  return useSWR<MyQuiz[], Error>(url, simpleFetcher);
}
